import Dialog from "@material-ui/core/Dialog";
import {
    Box,
    Button, Chip, DialogActions,
    DialogTitle, FormControl,
    Grid, InputLabel, Select,
    TextField
} from "@material-ui/core";
import * as React from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogActions from "@material-ui/core/DialogActions";
import {useEffect, useState} from "react";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {ElectionService} from "../Election/ElectionService";
import {CashGroupService} from "../../pages/CashGroups/CashGroupService";
import {convertToBirthDate, convertToTime} from "../../utils/numberConvertor";


const AddNewElections = ({openDialog, needRefresh, selectedItemId, handleClose}) => {


    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new ElectionService(fundID, token, snackbar, loading)
    const groupService = new CashGroupService(fundID, token, snackbar, loading)

    useEffect(() => {
        if (typeof groupService !== 'undefined') {
            getGroupList()
        }
    }, [])

    const [groupList, setGroupList] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState(-1);

    let candidateKey = 0
    const [candidatesList, setCandidatesList] = useState([]);

    const handleDelete = (chipToDelete) => () => {
        setCandidatesList((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
    };

    function getGroupList() {
        groupService.getCashGroupsList(fundID, 0, "", "", 1000000).then(response => {
            setGroupList(response.data)
        }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت اطلاعات گروه ها!"))
        })
    }


    const [headerTitle, setHeaderTitle] = useState(false)
    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const DialogActions = withStyles((theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(1),
        },
    }))(MuiDialogActions);
    //Dialog-end


    //state-start
    const [title, setTitle] = useState('')
    const [startDate, setStartDate] = useState('')
    const [startTime, setStartTime] = useState("");
    const [endDate, setEndDate] = useState('')
    const [endTime, setEndTime] = useState("");
    const [published, setPublished] = useState(false)
    const [options, setOptions] = useState("")
    const [description, setDescription] = useState('')

    //state-end

    function checkAllFields() {
        let status = true
        let message = ""
        if (title.trim().length === 0) {
            status = false
            message = "لطفا عنوان انتخابات را وارد نمایید!"
        } else if (selectedGroupId === -1) {
            status = false
            message = "لطفا گروه را انتخاب نمایید!"
        } else if (startDate.length !== 10) {
            status = false
            message = "لطفا تاریخ شروع انتخابات را به درستی وارد نمایید!"
        } else if (endDate.length !== 10) {
            status = false
            message = "لطفا تاریخ پایان انتخابات را به درستی وارد نمایید!"
        } else if (candidatesList.length === 0) {
            status = false
            message = "لطفا نام کاندیدا ها وارد نمایید!"
        }

        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return status

    }


    function doChange() {
        if (checkAllFields()) {
            needRefresh(true)
            if (selectedItemId === -1) {
                service.addNewElection(
                    fundID,
                    selectedGroupId,
                    service.prepareElectionData(
                        title,
                        startDate,
                        startTime,
                        endDate,
                        endTime,
                        published,
                        true,
                        candidatesList,
                        description
                    ),
                    clearFields
                )
            }
        }
    }

    function clearFields() {
        setTitle("")
        setStartDate("")
        setStartTime("")
        setEndDate("")
        setEndTime("")
        setSelectedGroupId(-1)
        setCandidatesList([])
        setDescription("")
        setPublished(false)
    }

    return (
        <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                id="customized-full-screen-dialog">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                {selectedItemId === -1 ? 'افزودن انتخابات جدید' : 'مشاهده انتخابات'}
            </DialogTitle>
            <section className="m-4">
                <Box className="flex-grow-1 w-100" sm={12}>
                    <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12} style={{marginTop: '1rem'}}>
                        <Grid sm={6} md={6} lg={6} xl={3} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="عنوان"
                                       value={title} onChange={e => {
                                setTitle(e.target.value)
                            }}/>
                        </Grid>
                        <Grid sm={6} md={6} lg={6} xl={3} className='p-2 w-100'>
                            <FormControl variant="outlined" className="w-100">
                                <InputLabel htmlFor="filled-age-native-simple">گروه</InputLabel>
                                <Select label="گروه"
                                        value={selectedGroupId}
                                        onChange={e => {
                                            setSelectedGroupId(e.target.value)
                                        }}>
                                    {groupList.map((item, index) => {
                                        return <option value={item.id}>{item.name}</option>

                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="تاریخ شروع"
                                       value={convertToBirthDate(startDate)}
                                       onChange={e => {
                                           setStartDate(convertToBirthDate(e.target.value))
                                       }}/>
                        </Grid>
                        <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="زمان شروع"
                                       value={convertToTime(startTime)}
                                       onChange={e => {
                                           setStartTime(convertToTime(e.target.value))
                                       }}/>
                        </Grid>
                        <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="تاریخ پایان"
                                       value={convertToBirthDate(endDate)}
                                       onChange={e => {
                                           setEndDate(convertToBirthDate(e.target.value))
                                       }}/>
                        </Grid>
                        <Grid sm={6} md={6} lg={3} xl={3} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="زمان پایان"
                                       value={convertToTime(endTime)}
                                       onChange={e => {
                                           setEndTime(convertToTime(e.target.value))
                                       }}/>
                        </Grid>
                        <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100 d-flex flex-column'>
                            <label id='residenceStatus' className="toggle-switch-content">
                                <span className="toggle-title">انتشار خودکار</span>
                                <label className="switch" htmlFor="MainCategory">
                                    <input
                                        type="checkbox"
                                        id="residenceStatus"
                                        checked={published}
                                        onChange={e => {
                                            setPublished(e.target.checked)
                                        }}
                                    />
                                    <span className="toggle round"/>
                                </label>
                            </label>
                            <span className="MuiFormHelperText-root MuiFormHelperText-contained">بعد از انتشار امکان ویرایش انتخابات وجود ندارد!</span>
                        </Grid>
                        <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                            <label className={candidatesList.length > 0 ? "d-block" : "d-none"}>کاندید ها</label>
                            <section className="d-flex flex-row">
                                {candidatesList.map((data) => {
                                    return (
                                        <Chip
                                            label={data.label}
                                            onDelete={handleDelete(data)}
                                            className="mx-2"
                                            key={data.key}
                                        />
                                    );
                                })}
                            </section>
                        </Grid>
                        <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>

                            <TextField
                                className="w-100"
                                label="کاندید جدید"
                                helperText="افزودن با اینتر"
                                variant="outlined"
                                value={options}
                                onChange={e => {
                                    setOptions(e.target.value)
                                }}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        const key = candidatesList.length > 0 ? parseInt(candidatesList[candidatesList.length - 1].key) + 1 : "0"
                                        setCandidatesList((prevState => [...prevState, {
                                            key: key,
                                            label: options
                                        }]))
                                        setOptions("")
                                    }
                                }}
                            />
                        </Grid>
                        <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                            <TextField
                                className="w-100"
                                label="توضیحات"
                                multiline
                                rows={6}
                                variant="outlined"
                                value={description}
                                onChange={e => {
                                    setDescription(e.target.value)
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </section>
            <DialogActions>
                <Button className="m-4" onClick={doChange} color="primary">
                    {selectedItemId === -1 ? "افزودن" : "بروزرسانی"}
                </Button>
            </DialogActions>
        </Dialog>

    )
}
export default AddNewElections


